import { render } from "./Main_rtRemote.vue?vue&type=template&id=96ae4c32&scoped=true"
import script from "./Main_rtRemote.vue?vue&type=script&lang=js"
export * from "./Main_rtRemote.vue?vue&type=script&lang=js"

import "./Main_rtRemote.vue?vue&type=style&index=0&id=96ae4c32&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ae4c32"]])

export default __exports__